import { render, staticRenderFns } from "./tgFrame.vue?vue&type=template&id=366ca9b2&scoped=true"
import script from "./tgFrame.vue?vue&type=script&lang=js"
export * from "./tgFrame.vue?vue&type=script&lang=js"
import style0 from "./tgFrame.vue?vue&type=style&index=0&id=366ca9b2&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "366ca9b2",
  null
  
)

export default component.exports